export default __webpack_public_path__ + "static/media/exploded-view_sprite.4b8a9c38.png";